<img src="./assets/images/paymentSuccess.png" alt="Stripe" style="max-width: 20%"/>
<p>Succesfully! You have paid premium account</p>
